import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from './NavBar/Navbar';
import { CgCopyright } from 'react-icons/cg';
import "./BaseLayout.css"

interface BaseLayoutProps {
  children: ReactNode;
}

const BaseLayout = (props: BaseLayoutProps) => (
  <div className="base-layout min-w-[320px]">
    <Navbar />
    <main className="base-main mt-24">
      {props.children}
    </main>
    <footer className="base-footer flex flex-col md:flex-row justify-between items-center py-4 !px-10">
      <div className='flex flex-1 gap-1 items-center text-base'>
        <CgCopyright size={18} />
        <p className='mb-0'>
          {`${new Date().getFullYear()} Ackerplus. All rights reserved.`}
        </p>
      </div>
      <div className='flex items-center gap-1'>
        <Link className="footer-link !text-sm" to="/impressum">Impressum</Link> |{"  "}  
        <Link className="footer-link !text-sm" to="https://stframcalendarprodchno01.blob.core.windows.net/farmcalendar/public/terms-and-conditions.pdf" target="_blank">AGB</Link> |{"  "}  
        <Link className="footer-link !text-sm" to='/contact'>Kontakt</Link>
      </div>
    </footer>
  </div>
);

export default BaseLayout;
